import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/news/loading.js");
